// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3JgJt","inputDescription":"styles_inputDescription__1uo0r"};